import * as Widgets from "@mm/constants/widgets";
import WidgetEntity from '../WidgetEntity';

export default class EmailWidget extends WidgetEntity {
  static make(pageId, sortOrder, recipient) {
    const widget = {
      ...super.make(pageId, Widgets.EMAIL, 'New lead', sortOrder),
      config: {
        kind: 'mobile',
        message: 'New lead',
        companyUserIdsToNotify: [],
        subject: 'New lead',
        body: `Customer Name: {{first name}} {{last name}}\nLink to conversation: {{link to conversation}}`,
        recipient,
      },
      title: '',
    };

    delete widget.title;

    return widget;
  }
}
